// Make this flag available to the client-side (JavaScript) SDK
// If you want these common features to appear client side ensure that in launch darkly the following checkbox is enabled
export type Features =
    | 'brightcove-player'
    | 'ix-header-tag-wrapper'
    | 'email-author'
    | 'google-tag-manager'
    | 'gpt-ads'
    | 'nielsen-events'
    | 'track-js'
    | 'refresh-on-inactive'
    | 'can-autoplay-video'
    | 'can-autoplay-muted-video'
    | 'can-autoplay-next'
    | 'big-mobile-amp'
    | 'related-content'
    | 'snowplow'
    | 'prebid-video'
    | 'debug-ads'
    | 'newsletter-subscription-banner'
    | 'sticky-mrec'
    | 'standalone-amp-swm-player'
    | 'moat-adx-ad-tracking'
    | 'nielsen-video-events'
    | 'inline-card-video'
    | 'search'
    | 'canary'
    | 'world-collection'
    | 'use-oovvuu-recommendation'
    | 'cricketball'
    | 'digital-subscriptions'
    | 'bonzai-truskin'
    | 'outstream'
    | 'ad-tech-dfp-testing'
    | 'nielsen-video-events-inline-videos'
    | 'grapeshot'
    | 'mmo-bypass'
    | 'paywall-bypass-header'
    | 'ripple'
    | 'regionals'
    | 'immersive-story-article-template'
    | 'telethon-countdown'
    | 'running-parallax'
    | 'logo-takeover'
    | 'afl-draft'
    | 'simple-digital-subscription-form'
    | 'moat-yield-intelligence'
    | 'exclude-regional-topics-from-lists'
    | 'video-playlist'
    | 'cookie-consent'
    | 'community-news'
    | 'puzzles-target'
    | 'the-west-live'
    | 'playlists-on-inline-videos'
    | 'native-lazy-loading'
    | 'force-west-live-activation'
    | 'video-series'
    | 'sport-breach-screen-variant'
    | 'taboola'
    | 'taboola-regionals'
    | 'companion-ads'
    | 'story-classification'
    | 'the-west-rewards'
    | 'registration-wall'
    | 'comments'
    | 'hero-image-as-video-poster'
    | 'native-chartbeat'
    | 'black-friday'
    | 'use-internal-content-api'
    | '50-off-breach-discount-govan50'
    | '50-off-breach-discount-coviddig'
    | 'adobe-audience-manager'
    | 'newsletter-subscriptions'
    | 'state-election-collection-topic-landing'
    | 'nielsen-subbrand'
    | 'app-upgrade-screen'
    | 'the-west-logo'
    | 'route-west-tonight'
    | '50-off-breach-discount'
    | 'south-west-curations'
    | 'sophi'
    | 'user-accounts'
    | '7news-taboola-midarticle'
    | 'cng-to-perth-now-rebrand'
    | 'route-up-late'
    | 'jab-tracker'
    | 'jab-tracker'
    | 'puzzles'
    | 'digital-edition-redirects'
    | 'the-west-grand-final'
    | 'perthnow-grand-final'
    | 'the-west-grand-final-collection'
    | 'perthnow-grand-final-collection'
    | 'perthnow-grand-final-play-of-the-day'
    | 'live-ramp-ats'
    | '7ent-article-related'
    | '7ent-show-page-7plus-button'
    | '7news-contextual-link'
    | 'the-west-cnbc'
    | 'subscribe-with-google'
    | '7ent-article-7plus-button'
    | '7ent-article-layout'
    | '7ent-show-layout'
    | 'cricket-widgets'
    | 'queens-legacy-listing'
    | 'queens-legacy-home'
    | 'swg-breach-default'
    | 'swg-breach-albany-advertiser'
    | 'swg-breach-great-southern-herald'
    | 'swg-breach-augusta-margaret-river-times'
    | 'swg-breach-busselton-dunsborough-times'
    | 'swg-breach-broome-advertiser'
    | 'swg-breach-the-kimberley-echo'
    | 'swg-breach-geraldton-guardian'
    | 'swg-breach-midwest-times'
    | 'swg-breach-bunbury-herald'
    | 'swg-breach-harvey-waroona-reporter'
    | 'swg-breach-manjimup-bridgetown-times'
    | 'swg-breach-south-western-times'
    | 'swg-breach-kalgoorlie-miner'
    | 'swg-breach-narrogin-observer'
    | 'swg-breach-north-west-telegraph'
    | 'swg-breach-pilbara-news'
    | 'swg-breach-sound-telegraph'
    | 'swg-breach-countryman'
    | 'climate-change-home'
    | 'the-west-bar-regional'
    | 'taboola-bb-vip-show-page'
    | 'swg-entitlements-check'
    | 'perth-now-pride-logo'
    | '7-news-sport-curation-home-page-for-winters'
    | '7-news-winters-hamburger-menu'
    | '7-news-winters-contextual-link'
    | 'custom-sample-middleware'
    | 'feature-toggle-override'
    | 'subscriber-dropdown'
    | '7-lifestyle-full-page-layout'
    | 'subscriber-feature-tooltip'
    | '7-news-lifestyle-article-related-card'
    | '7-news-lifestyle-four-column-taboola-feed'
    | '7-news-lifestyle-article-full-page-display'
    | '7-news-sas-australia-article-full-page-display'
    | '7-news-sas-australia-article-7-plus-button'
    | '7-news-womens-afl-contextual-link'
    | 'entertainment-trending'
    | '7-news-lifestyle-contextual-link'
    | '7-news-sas-australia-full-page-layout'
    | '7-news-sas-australia-header'
    | '7-news-lifestyle-sub-topic-page-display'
    | '7-ent-sas-australia-show-page-watch-live-button'
    | '7-news-lifestyle-btyb-display'
    | 'hide-mobile-breaking-news-banner'
    | '7-news-sas-australia-article-related-card'
    | 'amp-read-more'
    | '7-news-dwts-full-show-page-display'
    | '7-news-lifestyle-right-hand-side-the-latest'
    | 'swg-account-linking'
    | '7-news-dwts-contextual-link'
    | '7news-dwts-full-article-page-display'
    | '7-entertainment-full-page-display'
    | '7-news-paralympic-winters-contextual-link'
    | '7-news-sas-australia-article-the-latest-right-hand-rail'
    | '7-entertainment-masthead'
    | '7-news-entertainment-sub-topic-page-display'
    | '7-politics-full-page-display'
    | '7-news-politics-full-page-article-display'
    | 'force-ads-hidden-until-loaded-false'
    | '7-news-sport-article-full-page-display'
    | '7-entertainment-article-full-page-display'
    | '7-news-sport-sub-topic-page-display'
    | '7-news-politics-sub-topic-page-display'
    | '7-entertainment-sunrise-full-article-display'
    | '7-entertainment-the-morning-show-full-article-display'
    | '7-news-sport-full-page-display'
    | '7-news-sunrise-full-page-display'
    | '7-news-finance-business-full-article-display'
    | '7-news-tech-full-page-display'
    | '7-news-tech-full-article-page-display'
    | '7-news-article-full-page-display'
    | '7-news-world-full-article-page-display'
    | '7-news-the-morning-show-full-page-display'
    | '7-news-sub-topic-page-display'
    | '7-news-tech-sub-topic-page-display'
    | '7-news-weather-topic-page'
    | '7-news-finance-topic-page'
    | '7-news-world-topic-page-display'
    | '7-news-home-page-full-page-display'
    | '7-news-weather-sub-topic-page-display'
    | '7-news-business-sub-topic-page'
    | '7-news-weather-full-article-page-display'
    | 'federal-election-2022'
    | 'federal-election-2022-election-day'
    | '7-news-the-voice-show-page'
    | '7-news-home-and-away-show-page'
    | '7-news-commonwealth-medal-tally-page'
    | '7-news-commonwealth-games-navigation-inclusion'
    | 'pollie-rater-drivers'
    | '7-news-commonwealth-games-topic-page-display'
    | 'federal-election-2022-federal-collection'
    | '7-news-commonwealth-games-schedule-page'
    | '7-news-commonwealth-games-live-results-page'
    | 'federal-election-2022-pollie-rater'
    | 'federal-election-2022-fact-checker'
    | '7-news-commonwealth-games-contextual-link'
    | '7-news-taboola-read-more-amp-articles'
    | 'federal-election-2022-landing-page-breaking-strap'
    | 'live-coverage-driver'
    | 'federal-election-hamburger-navigation-drivers'
    | '7-news-comm-games-masthead-header'
    | '7-news-pre-election-collection'
    | 'perthnow-federal-election-2022-curation'
    | '7-news-commonwealth-games-hub'
    | '7-news-spotlight-full-article-display'
    | 'federal-election-2022-pollie-rater-strap-driver'
    | '7-news-spotlight-show-page'
    | '7-news-comm-games-hub-sport-page'
    | '7-news-comm-games-hub-widget-pages'
    | 'federal-election-2022-accordion-widgets'
    | 'federal-election-2022-live-blog-drivers'
    | '7-news-federal-election-widgets'
    | 'federal-election-2022-election-day-widgets'
    | 'federal-election-2022-election-day-live-coverage-link'
    | '7-news-comm-games-hub-home-page'
    | 'federal-election-2022-PerthNow-homepage-theming'
    | 'federal-election-2022-PerthNow-homepage-graphs'

export type TestFeatureState = { [K in Features]: boolean }

export const testFeatureState: TestFeatureState = {
    'world-collection': true,
    'brightcove-player': true,
    'ix-header-tag-wrapper': true,
    'email-author': true,
    'google-tag-manager': true,
    'gpt-ads': true,
    'nielsen-events': true,
    'track-js': true,
    'refresh-on-inactive': false,
    'can-autoplay-video': true,
    'can-autoplay-next': false,
    'can-autoplay-muted-video': false,
    'big-mobile-amp': false,
    'related-content': false,
    snowplow: true,
    'prebid-video': true,
    search: false,
    'debug-ads': false,
    'newsletter-subscription-banner': false,
    'sticky-mrec': false,
    'standalone-amp-swm-player': false,
    'moat-adx-ad-tracking': true,
    'nielsen-video-events': true,
    'inline-card-video': true,
    canary: false,
    'use-oovvuu-recommendation': false,
    cricketball: false,
    'digital-subscriptions': false,
    'bonzai-truskin': false,
    outstream: false,
    'ad-tech-dfp-testing': true,
    'nielsen-video-events-inline-videos': false,
    grapeshot: false,
    'mmo-bypass': false,
    'paywall-bypass-header': true,
    ripple: false,
    regionals: true,
    'immersive-story-article-template': false,
    'telethon-countdown': false,
    'running-parallax': false,
    'logo-takeover': false,
    'afl-draft': false,
    'simple-digital-subscription-form': false,
    'moat-yield-intelligence': false,
    'exclude-regional-topics-from-lists': false,
    'video-playlist': false,
    'cookie-consent': false,
    'community-news': true,
    'cng-to-perth-now-rebrand': true,
    'the-west-live': false,
    'playlists-on-inline-videos': false,
    'native-lazy-loading': false,
    'force-west-live-activation': false,
    'video-series': true,
    'sport-breach-screen-variant': true,
    taboola: true,
    'taboola-regionals': true,
    'companion-ads': false,
    'story-classification': true,
    'the-west-rewards': true,
    'registration-wall': true,
    comments: false,
    'hero-image-as-video-poster': true,
    'native-chartbeat': true,
    'black-friday': false,
    'use-internal-content-api': true,
    '50-off-breach-discount-govan50': false,
    '50-off-breach-discount-coviddig': false,
    'adobe-audience-manager': false,
    'newsletter-subscriptions': true,
    'state-election-collection-topic-landing': false,
    'nielsen-subbrand': true,
    'app-upgrade-screen': true,
    'the-west-logo': true,
    'route-west-tonight': true,
    '50-off-breach-discount': false,
    'south-west-curations': false,
    sophi: false,
    'user-accounts': false,
    '7news-taboola-midarticle': true,
    'route-up-late': true,
    'jab-tracker': true,
    'puzzles-target': false,
    puzzles: true,
    'digital-edition-redirects': true,
    'the-west-grand-final': true,
    'perthnow-grand-final': true,
    'the-west-grand-final-collection': true,
    'perthnow-grand-final-collection': true,
    'perthnow-grand-final-play-of-the-day': true,
    'live-ramp-ats': true,
    '7ent-article-related': true,
    '7ent-show-page-7plus-button': true,
    '7news-contextual-link': true,
    'the-west-cnbc': true,
    'subscribe-with-google': false,
    '7ent-article-7plus-button': true,
    '7ent-article-layout': true,
    '7ent-show-layout': true,
    'cricket-widgets': true,
    'queens-legacy-listing': false,
    'queens-legacy-home': false,
    'swg-breach-default': false,
    'swg-breach-albany-advertiser': false,
    'swg-breach-great-southern-herald': false,
    'swg-breach-augusta-margaret-river-times': false,
    'swg-breach-busselton-dunsborough-times': false,
    'swg-breach-broome-advertiser': false,
    'swg-breach-the-kimberley-echo': false,
    'swg-breach-geraldton-guardian': false,
    'swg-breach-midwest-times': false,
    'swg-breach-bunbury-herald': false,
    'swg-breach-harvey-waroona-reporter': false,
    'swg-breach-manjimup-bridgetown-times': false,
    'swg-breach-south-western-times': false,
    'swg-breach-kalgoorlie-miner': false,
    'swg-breach-narrogin-observer': false,
    'swg-breach-north-west-telegraph': false,
    'swg-breach-pilbara-news': false,
    'swg-breach-sound-telegraph': false,
    'swg-breach-countryman': false,
    'climate-change-home': false,
    'the-west-bar-regional': true,
    'taboola-bb-vip-show-page': true,
    'swg-entitlements-check': false,
    'perth-now-pride-logo': false,
    '7-news-winters-hamburger-menu': false,
    '7-news-sport-curation-home-page-for-winters': false,
    '7-news-winters-contextual-link': true,
    'custom-sample-middleware': false,
    'feature-toggle-override': true,
    'subscriber-dropdown': true,
    '7-lifestyle-full-page-layout': true,
    'subscriber-feature-tooltip': true,
    '7-news-lifestyle-article-related-card': true,
    '7-news-lifestyle-four-column-taboola-feed': true,
    '7-news-lifestyle-article-full-page-display': true,
    '7-news-sas-australia-article-full-page-display': true,
    '7-news-sas-australia-article-7-plus-button': true,
    '7-news-womens-afl-contextual-link': true,
    '7-news-lifestyle-contextual-link': true,
    'entertainment-trending': false,
    '7-news-sas-australia-full-page-layout': true,
    '7-news-sas-australia-header': true,
    '7-news-lifestyle-sub-topic-page-display': true,
    '7-ent-sas-australia-show-page-watch-live-button': true,
    '7-news-lifestyle-btyb-display': true,
    'hide-mobile-breaking-news-banner': true,
    '7-news-sas-australia-article-related-card': true,
    'amp-read-more': true,
    '7-news-dwts-full-show-page-display': true,
    '7-news-lifestyle-right-hand-side-the-latest': true,
    'swg-account-linking': false,
    '7-news-dwts-contextual-link': true,
    '7news-dwts-full-article-page-display': true,
    '7-entertainment-full-page-display': true,
    '7-news-paralympic-winters-contextual-link': true,
    '7-news-sas-australia-article-the-latest-right-hand-rail': true,
    '7-entertainment-masthead': true,
    '7-news-entertainment-sub-topic-page-display': true,
    '7-politics-full-page-display': true,
    '7-news-politics-full-page-article-display': true,
    'force-ads-hidden-until-loaded-false': true,
    '7-news-sport-article-full-page-display': true,
    '7-entertainment-article-full-page-display': true,
    '7-news-sport-sub-topic-page-display': true,
    '7-news-politics-sub-topic-page-display': true,
    '7-entertainment-sunrise-full-article-display': true,
    '7-entertainment-the-morning-show-full-article-display': true,
    '7-news-sport-full-page-display': true,
    '7-news-sunrise-full-page-display': true,
    '7-news-finance-business-full-article-display': true,
    '7-news-tech-full-page-display': true,
    '7-news-tech-full-article-page-display': true,
    '7-news-article-full-page-display': true,
    '7-news-world-full-article-page-display': true,
    '7-news-the-morning-show-full-page-display': true,
    '7-news-sub-topic-page-display': true,
    '7-news-tech-sub-topic-page-display': true,
    '7-news-weather-topic-page': true,
    '7-news-finance-topic-page': true,
    '7-news-world-topic-page-display': true,
    '7-news-home-page-full-page-display': true,
    '7-news-weather-sub-topic-page-display': true,
    '7-news-business-sub-topic-page': true,
    '7-news-weather-full-article-page-display': true,
    'federal-election-2022': true,
    'federal-election-2022-election-day': true,
    '7-news-the-voice-show-page': true,
    '7-news-home-and-away-show-page': true,
    '7-news-commonwealth-medal-tally-page': true,
    '7-news-commonwealth-games-navigation-inclusion': true,
    'pollie-rater-drivers': true,
    '7-news-commonwealth-games-topic-page-display': true,
    'federal-election-2022-federal-collection': true,
    '7-news-commonwealth-games-schedule-page': true,
    '7-news-commonwealth-games-live-results-page': true,
    'federal-election-2022-pollie-rater': true,
    'federal-election-2022-fact-checker': true,
    '7-news-commonwealth-games-contextual-link': true,
    '7-news-taboola-read-more-amp-articles': true,
    'federal-election-2022-landing-page-breaking-strap': true,
    'live-coverage-driver': true,
    'federal-election-hamburger-navigation-drivers': true,
    '7-news-comm-games-masthead-header': true,
    '7-news-pre-election-collection': true,
    'perthnow-federal-election-2022-curation': true,
    '7-news-commonwealth-games-hub': true,
    '7-news-spotlight-full-article-display': true,
    'federal-election-2022-pollie-rater-strap-driver': true,
    '7-news-spotlight-show-page': true,
    '7-news-comm-games-hub-sport-page': true,
    '7-news-comm-games-hub-widget-pages': true,
    'federal-election-2022-accordion-widgets': true,
    'federal-election-2022-live-blog-drivers': true,
    '7-news-federal-election-widgets': true,
    'federal-election-2022-election-day-widgets': true,
    'federal-election-2022-election-day-live-coverage-link': true,
    '7-news-comm-games-hub-home-page': true,
    'federal-election-2022-PerthNow-homepage-theming': true,
    'federal-election-2022-PerthNow-homepage-graphs': true,
}
